module.exports = __webpack_public_path__ + "img/withdrawal-reminder.41c70993.svg";